import { Field, FieldProps } from 'formik';
import { FormHelperText, Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PoolSelect, PoolTypography, SelectOption } from '@synergy/components';
import { fields } from '@synergy/utils';
import { paymentMethodTranslationMap } from '@synergy/models';

import { PaymentTermAutocomplete } from '../../../../../../common/components/payment-term-autocomplete/payment-term-autocomplete';
import { SupplierConditionsFormValues } from '../models/supplier-conditions-form-values';
import { TaxRateAutocomplete } from '../../../../../../common/components/tax-rate-autocomplete/tax-rate-autocomplete';

export const SupplierDetailConditionsPayment = () => {
    const fieldNames = fields<SupplierConditionsFormValues>();

    const paymentMethodOptions: SelectOption[] = paymentMethodTranslationMap.map(paymentMethod => ({
        value: paymentMethod.value,
        displayValue: <FormattedMessage id={paymentMethod.translationKey} />,
    }));

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
                <PoolTypography styleType="sectionTitleNew" id="app.contactsAndOrganizations.conditions.payment" />
            </Grid>

            <Grid item={true} xs={12}>
                <PaymentTermAutocomplete
                    name={fieldNames.paymentTermId}
                    required={true}
                    useId={true}
                    label={<FormattedMessage id="app.contactsAndOrganizations.detail.paymentTerms.customer" />}
                />
            </Grid>

            <Grid item={true} xs={12}>
                <PaymentTermAutocomplete
                    name={fieldNames.poolPaymentTermId}
                    useId={true}
                    label={<FormattedMessage id="app.contactsAndOrganizations.detail.paymentTerms.pool" />}
                />
            </Grid>

            <Grid item={true} xs={6}>
                <TaxRateAutocomplete useId={true} />
            </Grid>

            <Grid item={true} xs={6}>
                <Field name={fieldNames.paymentMethod}>
                    {({ field, form, meta }: FieldProps<string>) => (
                        <>
                            <PoolSelect
                                {...field}
                                fullWidth={true}
                                options={paymentMethodOptions}
                                onValueChange={id => form.setFieldValue(field.name, id)}
                                label={<FormattedMessage id="app.contactsAndOrganizations.detail.paymentMethod" />}
                                required={true}
                                error={!!meta.touched && !!meta.error}
                                disallowDefaultValue={true}
                            />
                            {meta.error && meta.touched && (
                                <FormHelperText error={true}>
                                    <FormattedMessage id={meta.error} />
                                </FormHelperText>
                            )}
                        </>
                    )}
                </Field>
            </Grid>
        </Grid>
    );
};
